@if (content()) {
  <div [class]="theme.root">
    <div class="container {{ theme.container }}">
      <div class="wysiwyg" [innerHTML]="content()"></div>
    </div>
  </div>
}
